import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightIcon", "darkIcon", "systemIcon", "label", "tooltip"]

  connect() {
    this.updateUI(this.currentTheme)
    
    // Bind the system preference change listener if it's the first controller on the page
    if (!window.themeListenerBound) {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        if (this.currentTheme === 'system') {
          this.applyTheme('system')
          this.broadcastChange('system')
        }
      })
      window.themeListenerBound = true
    }
  }

  toggle(event) {
    event.preventDefault()
    let theme = this.currentTheme
    let nextTheme
    if (theme === 'system') {
      nextTheme = 'light'
    } else if (theme === 'light') {
      nextTheme = 'dark'
    } else {
      nextTheme = 'system'
    }
    
    localStorage.setItem('theme', nextTheme)
    this.applyTheme(nextTheme)
    this.updateUI(nextTheme)
    this.broadcastChange(nextTheme)
  }

  sync(event) {
    this.updateUI(event.detail.theme)
  }

  get currentTheme() {
    return localStorage.getItem('theme') || 'system'
  }

  applyTheme(theme) {
    const isAdmin = window.location.pathname.startsWith('/admin')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const isDark = theme === 'dark' || (theme === 'system' && prefersDark)
    
    if (!isAdmin && isDark) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  broadcastChange(theme) {
    window.dispatchEvent(new CustomEvent("theme:changed", { detail: { theme } }))
  }

  updateUI(theme) {
    // Hide all icons
    if (this.hasLightIconTarget) this.lightIconTarget.classList.add('hidden')
    if (this.hasDarkIconTarget) this.darkIconTarget.classList.add('hidden')
    if (this.hasSystemIconTarget) this.systemIconTarget.classList.add('hidden')

    // Show active icon and update text label/tooltip
    if (theme === 'light') {
      if (this.hasLightIconTarget) this.lightIconTarget.classList.remove('hidden')
      if (this.hasLabelTarget) this.labelTarget.textContent = 'Light'
      if (this.hasTooltipTarget) this.tooltipTarget.textContent = 'Theme: Light'
    } else if (theme === 'dark') {
      if (this.hasDarkIconTarget) this.darkIconTarget.classList.remove('hidden')
      if (this.hasLabelTarget) this.labelTarget.textContent = 'Dark'
      if (this.hasTooltipTarget) this.tooltipTarget.textContent = 'Theme: Dark'
    } else {
      if (this.hasSystemIconTarget) this.systemIconTarget.classList.remove('hidden')
      if (this.hasLabelTarget) this.labelTarget.textContent = 'System'
      if (this.hasTooltipTarget) this.tooltipTarget.textContent = 'Theme: System'
    }
  }
}
